import React from "react";
import { settings } from "app";
import { DocumentServicePath, DocumentsType, PRIVATE_DOCUMENTS, PUBLIC_DOCUMENTS } from "utils/constants";
import { BlobImagePreview } from "server/components";

const ImagePreview = ({ id, type = DocumentsType.PUBLIC }) => {
  const url = id
    ? `${settings.gatewayApi}/${DocumentServicePath}${type === DocumentsType.PUBLIC ? PUBLIC_DOCUMENTS : PRIVATE_DOCUMENTS}/${id}`
    : null;

  return (
    <BlobImagePreview
      url={url}
      alt="Профилна снимка"
      imgStyle={{
        border: "1px solid #e6cced",
        width: 200,
        height: 200,
        objectFit: "cover",
        objectPosition: "center",
      }}
      fallback={<p>Няма качена снимка</p>}
    />
  );
};

export default ImagePreview;
